import { numberWithCommas } from "@/components/utils.js";

const getters = {
  isAuth(state) {
    return !!state.token;
  },

  itemStatistics(state) {
    const types = [
      {
        type: 0,
        label: "띠형배너",
      },
      {
        type: 1,
        label: "팝업배너",
      },
      {
        type: 2,
        label: "이벤트",
      },
      {
        type: 3,
        label: "푸시알림",
      },
    ];

    let result = [[{ data: null }]];

    if (state.statistic && state.statistic.campaign_item_stat) {
      const items = state.statistic.campaign_item_stat;

      /**
       * { data: "띠형배너", header: true },
       * { data: "팝업배너", header: true },
       * { data: "이벤트", header: true },
       * { data: "푸시알림", header: true },
       */

      const noneHeaderItems = items.slice(1, items.length);

      for (let j = 0; j < noneHeaderItems.length; j++) {
        if (noneHeaderItems[j] && noneHeaderItems[j].length !== 0) {
          const typeIndex = noneHeaderItems[j][0].type;

          result[0].push({
            data: types[typeIndex].label,
            header: true,
          });
        }
      }

      result[0].push({ data: "통계", header: true });

      // items[0] = date, total data
      const tHeader = items[0];
      const banner = items[1] || [];
      const popup = items[2] || [];
      const event = items[3] || [];
      const push = items[4] || [];

      const tHeaderTotal = {
        view: 0,
        click: 0,
      };

      const bannerTotal = {
        view: 0,
        click: 0,
      };

      const popupTotal = {
        view: 0,
        click: 0,
      };

      const eventTotal = {
        view: 0,
        click: 0,
      };

      const pushTotal = {
        view: 0,
        click: 0,
      };

      for (let i = 0; i < items[0].length; i++) {
        const { date } = tHeader[i];

        let column = [
          {
            data: {
              date,
            },
          },
        ];

        if (banner.length !== 0) {
          const bid = banner.findIndex((b) => b.date === date);

          if (banner[bid]) {
            bannerTotal.view += parseInt(banner[bid].item_view);
            bannerTotal.click += parseInt(banner[bid].item_click);
          }

          column.push({
            data:
              bid === -1
                ? null
                : {
                    click: numberWithCommas(banner[bid].item_click),
                    view: numberWithCommas(banner[bid].item_view),
                  },
          });
        }

        if (popup.length !== 0) {
          const pid = popup.findIndex((b) => b.date === date);

          if (popup[pid]) {
            popupTotal.view += parseInt(popup[pid].item_view);
            popupTotal.click += parseInt(popup[pid].item_click);
          }

          column.push({
            data:
              pid === -1
                ? null
                : {
                    click: numberWithCommas(popup[pid].item_click),
                    view: numberWithCommas(popup[pid].item_view),
                  },
          });
        }

        // 이벤트를 등록하지 않으면 여기가 push 가 될 수가 있다.
        if (event.length !== 0) {
          const eid = event.findIndex((b) => b.date === date);

          // 빈값이 오는 경우가 있음
          if (event[eid]) {
            eventTotal.view += parseInt(event[eid].item_view);
            eventTotal.click += parseInt(event[eid].item_click);
          }

          column.push({
            data:
              eid === -1
                ? null
                : {
                    click: numberWithCommas(event[eid].item_click),
                    view: numberWithCommas(event[eid].item_view),
                  },
          });
        }

        if (push.length !== 0) {
          const pid = push.findIndex((b) => b.date === date);

          // 빈값이 오는 경우가 있음
          if (push[pid]) {
            pushTotal.view += parseInt(push[pid].item_view);
            pushTotal.click += parseInt(push[pid].item_click);
          }

          column.push({
            data:
              pid === -1
                ? null
                : {
                    click: numberWithCommas(push[pid].item_click),
                    view: numberWithCommas(push[pid].item_view),
                  },
          });
        }

        tHeaderTotal.view += parseInt(tHeader[i].item_view);
        tHeaderTotal.click += parseInt(tHeader[i].item_click);

        column.push({
          data: {
            click: numberWithCommas(tHeader[i].item_click),
            view: numberWithCommas(tHeader[i].item_view),
          },
        });

        result.push(column);
      }

      const totalColumn = [{ data: { date: "TOTAL" } }];

      if (banner.length !== 0) {
        totalColumn.push({
          data: {
            click: numberWithCommas(bannerTotal.click),
            view: numberWithCommas(bannerTotal.view),
          },
        });
      }

      if (popup.length !== 0) {
        totalColumn.push({
          data: {
            click: numberWithCommas(popupTotal.click),
            view: numberWithCommas(popupTotal.view),
          },
        });
      }

      if (event.length !== 0) {
        totalColumn.push({
          data: {
            click: numberWithCommas(eventTotal.click),
            view: numberWithCommas(eventTotal.view),
          },
        });
      }

      if (push.length !== 0) {
        totalColumn.push({
          data: {
            click: numberWithCommas(pushTotal.click),
            view: numberWithCommas(pushTotal.view),
          },
        });
      }

      // 통계
      totalColumn.push({
        data: {
          view: numberWithCommas(tHeaderTotal.view),
          click: numberWithCommas(tHeaderTotal.click),
        },
      });
      result.push(totalColumn);
    }

    return result;
  },
};

export default getters;
